function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.001h-.666V.668h-1.334v1.333H4.667V.668H3.333v1.333h-.666c-.734 0-1.334.6-1.334 1.334V14c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V3.335c0-.734-.6-1.334-1.334-1.334zm0 12H2.667V6.668h10.666v7.333zm0-8.666H2.667v-2h10.666v2z",
    fill: props.fill
  }));
}
export default SvgCalender;